__turbopack_context__.v({
  "desc": "_3dEqUG_desc",
  "download": "_3dEqUG_download",
  "excerptDate": "_3dEqUG_excerptDate",
  "links": "_3dEqUG_links",
  "newsExcerptsItem": "_3dEqUG_newsExcerptsItem",
  "title2": "_3dEqUG_title2",
  "top": "_3dEqUG_top",
});
